module.exports = __webpack_public_path__ + "img/12.2f5c650.png";